import React from 'react'
import { Typography } from '@mui/material'
import { advancedColors } from '../../../theme'

const PrefillLoading = () => (
  <Typography variant="body2" sx={{ color: advancedColors.inkMuted }}>
    Loading the participant’s details…
  </Typography>
)

export default PrefillLoading
